module.exports = __webpack_public_path__ + "img/bioOK.2c0dff6e.png";